import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ChevronLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  const { language } = useApp();

  // Set page title
  useEffect(() => {
    document.title = language === 'tr'
      ? 'Gizlilik Politikası | Kastamonu Amorium Hotel'
      : 'Privacy Policy | Kastamonu Amorium Hotel';
  }, [language]);

  return (
    <div style={{ minHeight: '100vh', background: '#F6F1E7' }}>
      <Navbar />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 1.5rem' }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#6E7F5B', textDecoration: 'none', marginBottom: '2rem' }}>
          <ChevronLeft size={14} /> {language === 'tr' ? 'Ana Sayfaya Dön' : 'Back to Home'}
        </Link>

        {language === 'tr' ? (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Gizlilik Politikası</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Son güncelleme: Mayıs 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. Genel Bilgiler</h2>
                <p>Amorium Hotel olarak, kişisel verilerinizin güvenliği ve gizliliği bizim için büyük önem taşımaktadır. Bu Gizlilik Politikası, web sitemizi ziyaret ettiğinizde veya rezervasyon yaptığınızda toplanan kişisel verilerinizin nasıl işlendiğini açıklamaktadır.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Toplanan Veriler</h2>
                <p>Rezervasyon sürecinde aşağıdaki kişisel bilgiler toplanmaktadır:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                  <li>Ad ve soyad</li>
                  <li>E-posta adresi</li>
                  <li>Telefon numarası</li>
                  <li>Adres bilgileri</li>
                  <li>Kimlik / pasaport numarası (yasal zorunluluk gereği)</li>
                  <li>Ödeme bilgileri (TEB Sanal POS altyapısı aracılığıyla güvenli şekilde işlenir)</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. Verilerin Kullanım Amacı</h2>
                <p>Toplanan veriler yalnızca aşağıdaki amaçlarla kullanılmaktadır:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                  <li>Rezervasyon işlemlerinin gerçekleştirilmesi</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Misafirlerle iletişim kurulması</li>
                  <li>Hizmet kalitesinin artırılması</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Veri Güvenliği</h2>
                <p>Kişisel verileriniz SSL şifreleme ve PCI-DSS uyumlu ödeme altyapısı ile korunmaktadır. Verileriniz üçüncü taraflarla paylaşılmamaktadır.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. Haklarınız</h2>
                <p>KVKK kapsamında verilerinize erişim, düzeltme ve silinmesini talep etme hakkına sahipsiniz. Bu talepleriniz için <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a> adresine ulaşabilirsiniz.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>6. İletişim</h2>
                <p>Gizlilik politikamız hakkında sorularınız için:<br />
                  📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a><br />
                  📍 Kumara Mah. Tekçam Mevkii No:7, Budamış Köyü / Kastamonu, 37210
                </p>
              </section>
            </div>
          </div>
        ) : (
          <div>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '36px', fontWeight: 600, color: '#1F3A2E', marginBottom: '8px' }}>Privacy Policy</h1>
            <p style={{ fontSize: '13px', color: '#6E7F5B', marginBottom: '2.5rem' }}>Last updated: May 2025</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', fontSize: '15px', lineHeight: '1.8', color: '#3A3632' }}>
              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>1. General Information</h2>
                <p>At Amorium Hotel, the security and privacy of your personal data is of great importance to us. This Privacy Policy explains how your personal data collected when you visit our website or make a reservation is processed.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>2. Data Collected</h2>
                <p>During the reservation process, the following personal information is collected:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                  <li>First and last name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Address information</li>
                  <li>ID / passport number (required by law)</li>
                  <li>Payment information (processed securely through TEB Virtual POS infrastructure)</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>3. Purpose of Data Use</h2>
                <p>Collected data is used only for the following purposes:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                  <li>Processing reservation transactions</li>
                  <li>Fulfilling legal obligations</li>
                  <li>Communicating with guests</li>
                  <li>Improving service quality</li>
                </ul>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>4. Data Security</h2>
                <p>Your personal data is protected with SSL encryption and PCI-DSS compliant payment infrastructure. Your data is not shared with third parties.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>5. Your Rights</h2>
                <p>You have the right to access, correct, and request deletion of your data. For these requests, you can reach us at <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a>.</p>
              </section>

              <section>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '22px', color: '#1F3A2E', marginBottom: '10px' }}>6. Contact</h2>
                <p>For questions about our privacy policy:<br />
                  📧 <a href="mailto:info@amoriumhotel.com" style={{ color: '#B08D57' }}>info@amoriumhotel.com</a><br />
                  📍 Kumara Mah. Tekçam Mevkii No:7, Budamış Köyü / Kastamonu, 37210, Turkey
                </p>
              </section>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
